import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import Row from '@sdk/components/ui/spacing/Row';
import formatTime from '@sdk/utils/dateFormat/formatTime';
import TranslateWithComponents from '@sdk/lang/TranslateWithComponents';
import useAuth from '@sdk/authentication/useAuth';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import type { TimesheetHistoryTimeEntry } from '@sdk/timesheets/types/TimesheetHistory';

type Props = {
  editedChange: TimesheetHistoryTimeEntry;
};

const TimesheetHistoryRowsForAddedClockOutEntry = ({ editedChange }: Props) => {
  const { currentUser } = useAuth();

  return (
    <>
      <Text14 themeColor={ThemeColorType.gray} mTop={5}>
        {gettext('Added time entry')}
      </Text14>

      <Row>
        <Text14 themeColor={ThemeColorType.gray}>
          <TranslateWithComponents
            replaceComponents={{
              time: (
                <Text14 themeColor={ThemeColorType.success}>
                  {formatTime(editedChange.clockOutTo, currentUser.settings.usTimeFormat)}
                </Text14>
              ),
            }}>
            {gettext('Out [[time]]')}
          </TranslateWithComponents>
        </Text14>
      </Row>
    </>
  );
};

export default TimesheetHistoryRowsForAddedClockOutEntry;
